import { render, staticRenderFns } from "./loginContainer.vue?vue&type=template&id=20c5cd1d&scoped=true&"
import script from "./loginContainer.vue?vue&type=script&lang=js&"
export * from "./loginContainer.vue?vue&type=script&lang=js&"
import style0 from "./loginContainer.vue?vue&type=style&index=0&id=20c5cd1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5cd1d",
  null
  
)

export default component.exports